
   export let appointmentCommitteeArray =[
        {id: 1,
        name: "Prof. Inam Ahmed",
        designation:"Chairman",
        organization:"Board of Intermediate Education Karachi"},
        {id: 2,
        name: "Dr. Saeed Uddin",
        designation:"Chairman",
        organization:"Board of Secondary Education Karachi"},    
        {id: 3,
        name: "Director (Colleges)",
        designation:"Sindh",
        organization:"Karachi"},    
        {id: 4,
        name: "Prof. Dr. Nasir Ansar",
        designation:"Director (Colleges)",
        organization:"Director (Colleges) Karachi"},    
        {id: 5,
        name: "Prof. Shahid Muhammad Din (Rtd)",
        designation:"RTD",
        organization:""}];


       export  let financeCommitteeArray = [    
           {id: 1,
           name: "Prof. Inam Ahmed",
           designation:"Chairman",
           organization:"Board of Intermediate Education Karachi"},
           {id: 2,
           name: "Representative of the Finance Department",
           designation:"Sindh",
           organization:"Govt. of Sindh,Karachi"},    
           {id: 3,
           name: "Director (Colleges)",
           designation:"Sindh",
           organization:"Karachi"},    
           {id: 4,
           name: "Prof. Jalal Ud Din Chohan",
           designation:" Ex-Principal (BPS-20)",
           organization:"Govt.College of Commerce & Economics,Karachi"},    
           {id: 5,
           name: "Prof. Ghulam Ali Wassan",
           designation:"Principal (BPS-20)",
           organization:"Govt.Islamia Arts & Commerce College No.1 Abul hassan Ishphani Road,Karachi"}]



              
     export let academicCommitteeArray =  [
        {id: 1,
        name: "Prof. Inam Ahmed",
        designation:"Chairman",
        organization:"Board of Intermediate Education Karachi"},
        {id: 2,
        name: "Prof. Dr. Muhammad Shajeel Auj",
        designation:"Dean, Faculty of Islamic Studies",
        organization:"University of Karachi"},
        {
            id: 3,
            name: "Engr. Gulzar Ahmed Memon",
            designation: "Chief Engineer (Elect. & Mech.)",
            organization: "Karachi Water & Sewerage Board, Karachi,"
        }, {
            id: 4,
            name: "Prof. Dr. Rana Khalid Naeem",
            designation: "Department of Mathematics ",
            organization: "University of Karachi"
        }, {
            id: 5,
            name: "Prof. Dr.Khrsheed Abbasi",
            designation: "Chairperson Department of Sindhi",
            organization: "University of Karachi"
        }, {
            id: 6,
            name: "Prof. Dr. Zafar Iqbal",
            designation: "Chairman Department of Urdu",
            organization: "University of Karachi"
        }, {
            id: 7,
            name: "Prof. Dr. Nigar Sajjad Zaheer",
            designation: "Associate Professor Department of Islamic History",
            organization: "University of Karachi    "
        },
        {
            id: 8,
            name: "Prof. Mrs. Iffat Sohail",
            designation: "Principal",
            organization: "Govt. Degree Science & Commerce College Landhi 3 1/2"
        }, {
            id: 9,
            name: "Prof. S.M. Haider Taqvi",
            designation: "Ex- Principal",
            organization: "Govt. Primier College Karachi."
        }, {
            id: 10,
            name: "Prof. Syed Jawad Ahsan",
            designation: "Principal",
            organization: "Jinnah Govt. College Karachi."
        }, {
            id: 11,
            name: "Prof. Mrs. Nasreen Hussain",
            designation: "Principal",
            organization: "PECHS, Govt. College for Woman, Karachi"
        }, {
            id: 12,
            name: "Prof. Nasim Akhter",
            designation: "Principal",
            organization: "Shipowner's Govt College, North Nazimabad, Karachi"
        }, {
            id: 13,
            name: "Prof. Naseem Nighat Seema",
            designation: "Ex- Principal",
            organization: "APWA Govt. Girls Higher Secondary School, Liaquatabad, Karachi,"
        }, {
            id: 14,
            name: "Prof. Syeda Rafiq Fatima",
            designation: "Principal",
            organization: "Abdullah Govt. Girls Collge, Karachi"
        }, {
            id: 15,
            name: "Ms. Shahina Ali Raza",
            designation: "Principal",
            organization: "Aga Khan Higher Secondary School,"
        }, {
            id: 16,
            name: "Cdr. (R ) Shafaat Rasul Janjua",
            designation: "Principal",
            organization: "Army Public Intermediate College, Karachi,"
        }, {
            id: 17,
            name: "Cdr.(R) Abdul Razaq PN",
            designation: "Principal",
            organization: "Commecs Institute of Business & Emerging Scienes Karachi."
        },

        {
            id: 18,
            name: "Prof. Nazir Ahmed Jokhio",
            designation: "Principal",
            organization: "Knokar Village Gadap Karachi."
        }, {
            id: 19,
            name: "Cdr. (R ) Sikander Hayat Khan",
            designation: "Principal",
            organization: "Bahria Foundation College Nazimabad"
        }, {
            id: 20,
            name: "Prof. Badar Drukshan Yousuf",
            designation: "Ex- District officer , Education (Headquarters)",
            organization: "Govt. of Sindh Karachi"
        }, {
            id: 21,
            name: "Prof. Syed Mohsin Abbas",
            designation: "Not Provided",
            organization: " D.J. Sindh Govt. Science College Karachi."
        }, {
            id: 22,
            name: "Mrs. Mujeeb-Un-Nisa Issani",
            designation: "Ex-Director Education",
            organization: "Govt. of Sindh Karachi"
        }, {
            id: 23,
            name: "Prof. Muhammad Saeed Akhter",
            designation: "Not Provided",
            organization: "Jinnah Govt. College Karachi"
        }, {
            id: 24,
            name: "Prof. Dr. Fauzia Hassan",
            designation: "Not Provided",
            organization: "Department of Pharmaceutics University of Karachi."
        }, {
            id: 25,
            name: "Prof. Dr. Saleem Shahzad",
            designation: "Not Provided",
            organization: "Department of Agriculture University of Karachi."
        }, {
            id: 26,
            name: "Dr. Mirza Mahmood Baig",
            designation: "Associate Professor & Chairman",
            organization: "Department of Mathematics N.E.D University of Engineering & Technology Karachi."
        }, {
            id: 27,
            name: "Prof. Mrs. Dilshad Zafar",
            designation: "Not Provided",
            organization: "Department of Commerce university of Karachi."
        }, {
            id: 28,
            name: "Prof. Ms. Safia Urooj",
            designation: "Not Provided",
            organization: "Department of education University of Karachi."
        }, {
            id: 29,
            name: "Prof. Dr.hafiz Ihsanul Haque",
            designation: "Chairman",
            organization: "Department of Arabic University of Karachi."
        }, {
            id: 30,
            name: "Prof. Dr. Shehla Saleem Noori",
            designation: "Chairman",
            organization: "Department of Persian University of Karachi."
        }, {
            id: 31,
            name: "Prof. Nuzhar Perveen",
            designation: "Principal",
            organization: "APWA Govt. Girls Higher Secondary School, Liaqutabad, Karachi"
        }, {
            id: 32,
            name: "Prof. Dr. Zafar Iqbal",
            designation: "Chairman",
            organization: "Department of Urdu, University of Karachi"
        }, {
            id: 33,
            name: "Zameer Ahmed Khooso",
            designation: "Regional Director Colleges Karachi Region",
            organization: "Govt of Sindh"
        }];

